import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import client from "../../api/client";

export default function CheckoutCallback() {
  const [searchParams] = useSearchParams();
  const { reference: referenceParam } = useParams();
  const navigate = useNavigate();
  const reference =
    searchParams.get("reference") ||
    searchParams.get("trxref") ||
    referenceParam;

  const [status, setStatus] = useState("verifying"); // verifying | success | failed
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!reference) {
      setStatus("failed");
      return;
    }

    const token = localStorage.getItem("nd-rest-tkn");
    if (token) client.defaults.headers.Authorization = `Bearer ${token}`;

    client
      .post("/cohorts/verify-payment", { reference })
      .then((res) => {
        setInfo(res.data);
        setStatus("success");
      })
      .catch((err) => {
        const msg = err?.response?.data?.message;
        setInfo({ message: msg || "Payment verification failed." });
        setStatus("failed");
      });
  }, [reference]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 w-full max-w-md p-8 text-center">

        {status === "verifying" && (
          <>
            <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
              <div className="w-8 h-8 border-2 border-gray-200 border-t-[#F05A19] rounded-full animate-spin" />
            </div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Verifying your payment</h2>
            <p className="text-sm text-gray-500">Please wait while we confirm your enrollment…</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Enrollment Confirmed!</h2>
            <p className="text-sm text-gray-500 mb-1">
              {info?.course_title
                ? `You're now enrolled in "${info.course_title}".`
                : "Your payment was successful."}
            </p>
            {info?.status === "partial" && (
              <p className="text-xs text-amber-600 bg-amber-50 rounded-lg px-3 py-2 mt-3 mb-1">
                First installment paid. You can make further payments from your dashboard.
              </p>
            )}
            <p className="text-xs text-gray-400 mb-6">Reference: {reference}</p>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate("/dashboard")}
                className="w-full bg-[#F05A19] hover:bg-[#d14d14] text-white py-2.5 rounded-xl
                  font-medium text-sm transition-colors"
              >
                Go to Dashboard
              </button>
              <button
                onClick={() => navigate("/dashboard/my-courses")}
                className="w-full border border-gray-300 hover:bg-gray-50 text-gray-700 py-2.5
                  rounded-xl font-medium text-sm transition-colors"
              >
                View My Courses
              </button>
            </div>
          </>
        )}

        {status === "failed" && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Payment Not Confirmed</h2>
            <p className="text-sm text-gray-500 mb-4">
              {info?.message || "We could not verify your payment. If you were charged, please contact support."}
            </p>
            {reference && (
              <p className="text-xs text-gray-400 mb-6 font-mono break-all">{reference}</p>
            )}
            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate("/cohorts")}
                className="w-full bg-[#F05A19] hover:bg-[#d14d14] text-white py-2.5 rounded-xl
                  font-medium text-sm transition-colors"
              >
                Try Again
              </button>
              <button
                onClick={() => navigate("/dashboard")}
                className="w-full border border-gray-300 hover:bg-gray-50 text-gray-700 py-2.5
                  rounded-xl font-medium text-sm transition-colors"
              >
                Back to Dashboard
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
}
